var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer text-center",class:{ 'page-sidebar-minified': _vm.pageOptions.pageSidebarMinified },staticStyle:{"border-top":"1px solid #e4e4e4"},attrs:{"id":"footer"}},[_vm._v("\n\tQTrust - Copyright © 2023. All Rights Reserved.\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }